export default "__VITE_ASSET__Bdb$McHX__"